<!--PAGE-TOP-->
<app-header></app-header>
<!--/PAGE-TOP-->
<div class="i-page-content">
  <div class="container pb-5">
    <div class="row pt-3">
      <div class="col-12 text-center py-5">
        <h1 class="i-title">{{ this.title.toUpperCase() }}</h1>
      </div>
    </div>
    <form (ngSubmit)="onSend()" [formGroup]="fmGroup">
      <app-loading *ngIf="isMyData && !client"></app-loading>
      <div class="form-row px-2 px-lg-5">
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 i-text" appearance="fill">
          <mat-label class="i-text">NOME</mat-label>
          <input matInput type="text" class="i-text pb-1" maxlength="255" formControlName="name" />
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('name').errors?.required"> CAMPO OBRIGATÓRIO </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="isMyData" class="col-12 col-lg-8 mx-auto mb-3 i-text" appearance="fill">
          <mat-label class="i-text">CPF</mat-label>
          <input
            matInput
            type="text"
            class="i-text pb-1"
            placeholder="000.000.000-00"
            mask="000.000.000-00"
            maxlength="14"
            formControlName="cpf" />
        </mat-form-field>
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">TELEFONE</mat-label>
          <input
            matInput
            type="text"
            class="i-text pb-2"
            placeholder="(00) 0000-00000"
            mask="(00) 0000-0000||(00) 00000-0000"
            minlength="14"
            maxlength="15"
            formControlName="phone" />
          <mat-error
            class="i-text-sm mt-1"
            *ngIf="fmGroup.get('phone').errors?.minlength && !fmGroup.get('phone').errors?.required">
            POR FAVOR, INFORME NO MÍNIMO 14 DÍGITOS
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('phone').errors?.phoneSintaxError">
            POR FAVOR, VERIFIQUE O NÚMERO DIGITADO
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('phone').errors?.required">
            CAMPO OBRIGATÓRIO
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">E-MAIL</mat-label>
          <input matInput type="text" class="i-text pb-2" maxlength="255" formControlName="email" />
          <mat-error
            class="i-text-sm mt-1"
            *ngIf="fmGroup.get('email').errors?.email && !fmGroup.get('email').errors?.required">
            POR FAVOR, INFORME UM E-MAIL VÁLIDO
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('email').errors?.required">
            CAMPO OBRIGATÓRIO
          </mat-error>
        </mat-form-field>
        <div class="col-12 col-lg-8 mx-auto mb-3 mt-1 px-0">
          <mat-form-field class="col-6 i-text pl-0 pr-1" appearance="fill">
            <mat-label class="i-text">SENHA</mat-label>
            <input matInput type="password" class="i-text pb-1" maxlength="255" formControlName="pwd" />
            <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('pwd').errors?.required">
              CAMPO OBRIGATÓRIO
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-6 i-text pr-0 pl-1" appearance="fill">
            <mat-label class="i-text">REPITA A SENHA</mat-label>
            <input matInput type="password" class="i-text pb-1" maxlength="255" formControlName="repeatPwd" />
            <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('repeatPwd').errors?.required">
              CAMPO OBRIGATÓRIO
            </mat-error>
            <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('repeatPwd').errors?.passwordMustMatch">
              SENHAS NÃO CONFEREM
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <!--Button-->
      <div class="my-3 text-center"><button type="submit" class="i-btn ml-2">ENVIAR</button></div>
    </form>
    <div *ngIf="isMyData" class="container mt-5">
      <hr />
      <div class="row mt-5 flex-row justify-content-center">
        <div class="mx-3 mb-3">
          <a class="btn btn-outline-danger btn-sm" (click)="onRemove()">REMOVER MEUS DADOS</a>
        </div>
        <div class="mx-3 small text-muted">
          <b>Esta ação é permanente e afetará:</b>
          <dl>
            <li>Seus imóveis favoritos;</li>
            <li>Seus imóveis descartados;</li>
            <li>Comparação de imóveis;</li>
            <li>Personalização de conteúdo;</li>
            <li>Comunicação da Private com você.</li>
          </dl>
        </div>
      </div>
    </div>
  </div>
</div>
